import {ref, reactive, computed, watch, watchEffect} from 'vue';
import config from "@/config/config.json";

const pPanelState = reactive({
   isExpand:false,//tell whether the ppanel menu layout is expanded or collapsed
   activeMenu:config.reader.ppanel.menuCatalog,
   isCatalogEnabled:true,
   isToolEnabled:true,
   isResourcesEnabled:true,
   isUploadedResourcesEnabled:false,
   categoryContentHeight:0,
   catalogExpandedItems:[], //store which catalog items is/are expanded, so that when page is changed, the state can be kept.
})

export function usePpanel() {

    const reset = ()=> {
        console.log("reset @ppanel.js")
        pPanelState.isExpand = false;
        pPanelState.isCatalogEnabled = true;
        pPanelState.isToolEnabled = true;
        pPanelState.isResourcesEnabled = true;
        pPanelState.isUploadedResourcesEnabled = false;
        pPanelState.categoryContentHeight = 0;
        pPanelState.catalogExpandedItems = [];
    }

    const togglePpanel = ()=> {
        pPanelState.isExpand = !pPanelState.isExpand;
    }

    const updateCategoryHeight = () => {
        pPanelState.categoryContentHeight = pPanelState.pPanelHeight - document.querySelector("#ppanel .heading").clientHeight
    }

    const setActiveMenu = (menu)=> {
        pPanelState.activeMenu = menu;
    }

    const addCatalogExpandedItem = (id)=>{
        pPanelState.catalogExpandedItems.push(id);
    }

    const removeCatalogExpandedItem = (id)=>{
        let index =   pPanelState.catalogExpandedItems.indexOf(id)
        pPanelState.catalogExpandedItems.splice(index,1)
    }

    const isCatalogIdExpanded = (id) => {
        return  pPanelState.catalogExpandedItems.indexOf(id) >= 0;
    }

    return {
        pPanelState,
        togglePpanel,
        setActiveMenu,
        updateCategoryHeight,
        addCatalogExpandedItem,
        removeCatalogExpandedItem,
        isCatalogIdExpanded,
        reset
    }
}
